export type LocalizedNameFields = {
  name_en?: string | null;
  name_fa?: string | null;
  sur_name_en?: string | null;
  sur_name_fa?: string | null;
};

export function pickLocalizedField(
  locale: "en" | "fa",
  en?: string | null,
  fa?: string | null,
) {
  const primary = locale === "fa" ? fa : en;
  const fallback = locale === "fa" ? en : fa;
  const picked = (primary ?? "").trim() || (fallback ?? "").trim();
  return picked || "";
}

export function getLocalizedUserName(
  locale: "en" | "fa",
  user: LocalizedNameFields,
) {
  const name = pickLocalizedField(locale, user.name_en, user.name_fa);
  const surName = pickLocalizedField(
    locale,
    user.sur_name_en,
    user.sur_name_fa,
  );
  const fullName = `${name} ${surName}`.trim();
  const initials = `${name.charAt(0)}${surName.charAt(0)}`.trim();
  return { name, surName, fullName, initials };
}

